import { useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import styles from './expiringRent.module.scss';
import { showCardSeparator } from '../utils';
import ExpiringRentCard from './ExpiringRentCard/ExpiringRentCard';

function ExpiringRentContainer({ trackCallback = null }) {
  const { properties } = useSelector(
    (state) => state.DashboardSlice.expiringRentProperties
  );

  return (
    <Box className={styles.expiringRentContainer}>
      {properties.map((property, index) => (
        <Box key={property.id}>
          <ExpiringRentCard property={property} trackCallback={trackCallback} />
          {showCardSeparator(index, properties) && (
            <Box className={styles.separator} />
          )}
        </Box>
      ))}
    </Box>
  );
}

export default ExpiringRentContainer;
